const DropdownSeparator = () => {
  return (
    <div className="h-[1px] bg-gray-700 -mx-[5px]" />
  )
}

export default DropdownSeparator
